module.exports = __webpack_public_path__ + "static/media/AdmisionesUrgentes.5932997e.svg";